import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=08bbcd05&scoped=true&"
import script from "./reserve.vue?vue&type=script&lang=ts&"
export * from "./reserve.vue?vue&type=script&lang=ts&"
import style0 from "./reserve.vue?vue&type=style&index=0&id=08bbcd05&lang=less&scoped=true&"
import style1 from "./reserve.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bbcd05",
  null
  
)

export default component.exports